import React, { useEffect } from 'react';
import ServiceTemplate from '../components/ServiceTemplate';

const OperationalExcellence = () => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--service-bg-image',
      "url('https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2070&auto=format&fit=crop')"
    );
    return () => {
      document.documentElement.style.removeProperty('--service-bg-image');
    };
  }, []);
  const benefits = [
    {
      title: 'Increased Efficiency',
      description: 'Streamline operations and eliminate waste to significantly improve productivity and performance.'
    },
    {
      title: 'Cost Reduction',
      description: 'Identify and eliminate inefficiencies to reduce operational costs while maintaining quality.'
    },
    {
      title: 'Quality Improvement',
      description: 'Implement best practices and quality management systems to deliver superior products and services.'
    },
    {
      title: 'Employee Engagement',
      description: 'Foster a culture of continuous improvement that empowers employees and drives innovation.'
    }
  ];

  const features = [
    'Process mapping and optimization',
    'Lean management implementation',
    'Six Sigma methodologies',
    'Quality management systems',
    'Performance metrics and KPI development',
    'Workflow automation opportunities',
    'Supply chain optimization',
    'Continuous improvement programs',
    'Operational risk management',
    'Best practices implementation',
    'Change management support'
  ];

  const process = [
    {
      title: 'Current State Assessment',
      description: 'Conduct comprehensive analysis of existing operations to identify inefficiencies, bottlenecks, and improvement opportunities.'
    },
    {
      title: 'Gap Analysis',
      description: 'Compare current performance against best practices and industry benchmarks to identify improvement areas.'
    },
    {
      title: 'Solution Design',
      description: 'Develop customized operational improvement strategies and implementation plans tailored to your business needs.'
    },
    {
      title: 'Implementation',
      description: 'Execute improvement initiatives with hands-on support, training, and change management to ensure adoption.'
    },
    {
      title: 'Continuous Improvement',
      description: 'Establish ongoing monitoring and improvement processes to sustain gains and drive further optimization.'
    }
  ];

  return (
    <ServiceTemplate
      icon="⚙️"
      title="Operational Excellence"
      subtitle="Streamline processes and implement best practices to enhance efficiency and productivity"
      description="Our operational excellence services help organizations optimize their operations, reduce costs, and improve quality. We apply proven methodologies and best practices to streamline processes, eliminate waste, and build a culture of continuous improvement that drives sustainable operational performance."
      benefits={benefits}
      features={features}
      process={process}
      callToAction="Ready to transform your operations and achieve excellence? Contact us to discover how we can help optimize your business processes for maximum efficiency and performance."
    />
  );
};

export default OperationalExcellence;

